import { render, staticRenderFns } from "./MyEventDesc.vue?vue&type=template&id=adc09fb6&scoped=true&"
import script from "./MyEventDesc.vue?vue&type=script&lang=js&"
export * from "./MyEventDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc09fb6",
  null
  
)

export default component.exports